import { Button, DatePicker, Form, Input, Select, TimePicker, message } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import React, { useContext, useEffect, useState } from 'react';
import moment from 'moment';
import {
  getInstitutionByToken,
  getSubjectsWithIntitutionId,
  getClassesWithIntitutionId,
  getGroupsWithTeacherId,
  getLanguagesType,
  getTopicsBySubjectId,
  getGroupStudentsCount,
  getQuestionsLevelsCounts,
  createExam,
  updateExam,
  getQuestionTypes,
  getQuestionLevels,
} from '../../../actions';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Context } from '../../../defaults';
import ruRU from 'antd/lib/locale/ru_RU';
import {
  timeFormat,
  dateFormat,
  integerRegex,
  subjectsRegex,
  maxIntegerLengthRegex,
} from '../../../common';
import './index.css';

function CreateExam({
  setAdded,
  setActive,
  selectedExam,
  edit,
  setEdit,
  getFilteredExams,
  setSelectedGroup,
  setSelectedSubject,
}) {
  const { dictionary, language, setLoading } = useContext(Context);
  const [form] = useForm();
  const [institution, setInstitution] = useState();
  const [subjects, setSubjects] = useState();
  // const [classes, setClasses] = useState();
  const [questionTypes, setQuestionTypes] = useState();
  const [studentGroups, setStudentGroups] = useState();
  const [groupStudentsCount, setGroupStudentsCount] = useState(0);

  const [yearOfStudyRegex, setYearOfStudyRegex] = useState('');
  const [maxVariantRegex, setMaxVariantRegex] = useState('');
  const [numberOfQuestionsRegex, setNumberOfQuestionsRegex] = useState('');

  const [numberOfQuestionsByType, setNumberOfQuestionsByType] = useState([]);

  const [languagesType, setLanguagesType] = useState();
  const [topics, setTopics] = useState();
  const [questionLevels, setQuestionLevels] = useState();
  const [currentFilter, setCurrentFilter] = useState({ subjectId: null });
  const requiredMessage = dictionary?.FillTheField[language];

  const [date, setDate] = useState();

  const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 12 },
  };
  const tailLayout = {
    wrapperCol: { offset: 8, span: 16 },
  };

  function formattedRequest(data) {
    const levelA = [
      ...data.options.map((el) => {
        return {
          level: 'A',
          amount: el.LevelA,
          questionTypeId: el.questionTypeId,
        };
      }),
    ];
    const levelB = [
      ...data.options.map((el) => {
        return {
          level: 'B',
          amount: el.LevelB,
          questionTypeId: el.questionTypeId,
        };
      }),
    ];
    const levelC = [
      ...data.options.map((el) => {
        return {
          level: 'C',
          amount: el.LevelC,
          questionTypeId: el.questionTypeId,
        };
      }),
    ];
    const formattedData = {
      ...data,
      options: [...levelA, ...levelB, ...levelC],
      startTime: moment(data?.startTime?._d).format('HH:mm'),
      endTime: moment(data?.endTime?._d).format('HH:mm'),
      examDate: moment(data?.examDate?._d).format('YYYY.MM.DD'),
      endDate: moment(data?.endDate?._d).format('YYYY.MM.DD'),
    };

    return formattedData;
  }

  const onSaveExams = () => {
    if (rulesForDates('check', false)) {
      setLoading(true);
      form
        .validateFields()
        .then(() => {
          const data = formattedRequest(form.getFieldsValue());
          !edit &&
            createExam(data)
              .then(() => {
                setLoading(false);
                setAdded(true);
                setActive('2');
                setSelectedGroup(form.getFieldValue('groupId'));
                setSelectedSubject(form.getFieldValue('subjectId'));
                message.success(dictionary?.SuccessfullyAdded[language], 4);
                form.resetFields();
              })
              .catch(() => {
                message.error(dictionary?.SomethingWentWrong[language], 4);
                setLoading(false);
              });
          !!edit &&
            updateExam(data)
              .then(() => {
                setLoading(false);
                setEdit(false);
                getFilteredExams();
                message.success(dictionary?.SuccessfullyAdded[language], 4);
                form.resetFields();
              })
              .catch(() => {
                message.error(dictionary?.SomethingWentWrong[language], 4);
                setLoading(false);
              });
        })
        .catch(() => {
          setLoading(false);
          message.error(dictionary?.FormValidationFail[language], 4);
        });
    } else message.error(dictionary?.FormValidationFail[language], 4);
  };

  const rulesForDates = (name, value) => {
    var isRight = true;
    if (new Date(new Date().toDateString()) > new Date(form.getFieldValue('examDate')?._d)) {
      isRight = false;
      if (name === 'examDate')
        return {
          validateStatus: 'error',
          help: dictionary?.ExamStartDate[language] + dictionary?.FilledInCorrectly[language],
        };
    }
    if (
      new Date(new Date().toDateString()) > new Date(form.getFieldValue('endDate')?._d) ||
      new Date(form.getFieldValue('examDate')?._d) > new Date(form.getFieldValue('endDate')?._d)
    ) {
      isRight = false;
      if (name === 'endDate')
        return {
          validateStatus: 'error',
          help: dictionary?.ExamEndDate[language] + dictionary?.FilledInCorrectly[language],
        };
    }
    if (
      new Date().toDateString() === new Date(form.getFieldValue('examDate')?._d).toDateString() &&
      new Date() > new Date(form?.getFieldValue('startTime')?._d)
    ) {
      isRight = false;
      if (name === 'startTime')
        return {
          validateStatus: 'error',
          help: dictionary?.ExamStartTime[language] + dictionary?.FilledInCorrectly[language],
        };
    }
    if (
      (new Date().toDateString() === new Date(form.getFieldValue('endDate')?._d).toDateString() &&
        new Date() > new Date(form?.getFieldValue('endTime')?._d)) ||
      (new Date(form.getFieldValue('examDate')?._d).toDateString() ===
        new Date(form.getFieldValue('endDate')?._d).toDateString() &&
        new Date(form?.getFieldValue('startTime')?._d) >
          new Date(form?.getFieldValue('endTime')?._d))
    ) {
      isRight = false;
      if (name === 'endTime')
        return {
          validateStatus: 'error',
          help: dictionary?.ExamEndTime[language] + dictionary?.FilledInCorrectly[language],
        };
    }
    if (!!form.getFieldValue(name)) return { validateStatus: 'success', help: null };
    if (name === 'check') return isRight;
  };

  const getQuestionsCount = (questionTypeId) => {
    getQuestionsLevelsCounts({
      questionTypeId,
      subjectId: form.getFieldValue('subjectId'),
      topicsId: form.getFieldValue('topicsId'),
      langId: form.getFieldValue('langId'),
      yearOfStudy: form.getFieldValue('yearOfStudy'),
    }).then(({ data }) => setNumberOfQuestionsByType(data));
  };

  const maxLevelRegex = (id, questionType) => {
    const question = numberOfQuestionsByType.find(
      (el) => el[2] == form?.getFieldValue('options')[id]?.questionTypeId && el[0] == questionType,
    );

    if (!!question) return question[1];
  };

  const maxLevelsSizeRegex = (id) => {
    var sumLevel =
      parseInt(form?.getFieldValue('options')[id]?.LevelA) +
      parseInt(form?.getFieldValue('options')[id]?.LevelB) +
      parseInt(form?.getFieldValue('options')[id]?.LevelC);
    return sumLevel;
  };

  const rulesForQuestionTypeId = (fieldId) => {
    const option = form?.getFieldValue('options');
    if (fieldId !== undefined && !!option && !!option[fieldId]) {
      for (let i = 0; i < option.length; i++) {
        if (i !== fieldId) {
          if (
            !!option[i]?.questionTypeId &&
            !!option[fieldId]?.questionTypeId &&
            option[i]?.questionTypeId === option[fieldId]?.questionTypeId
          ) {
            return {
              validateStatus: 'error',
              help: dictionary?.ImpossibleQuestionType[language],
            };
          }
        }
      }
      if (!option[fieldId]?.questionTypeId) {
        return { validateStatus: 'error', help: requiredMessage };
      }
      return { validateStatus: 'success', help: null };
    }
  };

  const onChangeGroup = (value) => {
    getGroupStudentsCount(value).then(({ data }) => {
      setGroupStudentsCount(data);
      setMaxVariantRegex(maxIntegerLengthRegex(data));
    });
  };

  useEffect(() => {
    getInstitutionByToken().then(({ data }) => {
      setInstitution(data);
      setYearOfStudyRegex(subjectsRegex(data.studyYearFrom, data.studyYearTo));
    });
    getSubjectsWithIntitutionId().then(({ data }) => setSubjects(data));
    // getClassesWithIntitutionId().then(({ data }) => setClasses(data));
    getGroupsWithTeacherId().then(({ data }) => setStudentGroups(data));
    getLanguagesType().then(({ data }) => setLanguagesType(data));
    getQuestionTypes().then(({ data }) => setQuestionTypes(data));
    getQuestionLevels().then(({ data }) => setQuestionLevels(data));

    if (!!selectedExam) {
      setCurrentFilter({ subjectId: selectedExam?.subjectId });
      getTopicsBySubjectId(selectedExam?.subjectId).then(({ data }) => setTopics(data));
    }
  }, [selectedExam]);

  useEffect(() => {
    if (!!selectedExam) {
      form.setFieldsValue(selectedExam);
      onChangeGroup(selectedExam?.groupId);
      var amount = 0;
      form.getFieldValue('options').map((el) => (amount += parseInt(el?.amount)));
      setNumberOfQuestionsRegex(amount);
    }
  }, [form, selectedExam]);

  return (
    <React.Fragment>
      <h1 style={{ textAlign: 'center' }}>{!edit && dictionary?.CreateExam[language]}</h1>
      <Form
        form={form}
        layout="horizontal"
        {...formItemLayout}
        initialValues={!edit && { options: [''] }}>
        <Form.Item name="id" style={{ display: 'none' }}>
          <Input type={'hidden'} />
        </Form.Item>
        <Form.Item name="teacherId" style={{ display: 'none' }}>
          <Input type={'hidden'} />
        </Form.Item>
        <Form.Item
          label={dictionary?.ExamName[language]}
          name="name"
          rules={[
            { required: true, message: requiredMessage },
            { min: 1, message: dictionary?.MaxLengthField[language] },
            { max: 100, message: dictionary?.MaxLengthField[language] },
          ]}>
          <Input placeholder={dictionary?.ExamName[language]} />
        </Form.Item>
        <Form.Item
          name="subjectId"
          label={dictionary?.Subject[language]}
          rules={[{ required: true, message: requiredMessage }]}>
          <Select
            allowClear={true}
            showSearch={true}
            onChange={(e, data) => {
              form.setFieldsValue({
                topicsId: [],
              });
              setCurrentFilter({ subjectId: data?.value });
              getTopicsBySubjectId(data?.value).then(({ data }) => setTopics(data));
              !!e &&
                form.setFieldsValue({
                  langId: subjects.find((i) => i.id === e).langId,
                  yearOfStudy: subjects.find((i) => i.id === e).studyYear,
                });
            }}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            style={{ width: 200 }}
            placeholder={dictionary?.Subject[language]}>
            {subjects &&
              subjects.map((el) => {
                return (
                  <Select.Option value={el.id} key={el.id}>
                    {el.name}
                  </Select.Option>
                );
              })}
          </Select>
        </Form.Item>
        <Form.Item
          label={dictionary?.StudyYear[language]}
          name="yearOfStudy"
          rules={[
            { required: true, message: requiredMessage },
            {
              pattern: integerRegex,
              message: dictionary?.OnlyNumber[language],
            },
            {
              pattern: yearOfStudyRegex,
              message: dictionary?.InvalidStudyYear[language].replace(
                'diapasone',
                `${institution?.studyYearFrom}-${institution?.studyYearTo}`,
              ),
            },
          ]}>
          <Input placeholder={dictionary?.StudyYear[language]} disabled={true} />
        </Form.Item>

        {/* <Form.Item
          name="classId"
          label={dictionary?.Class[language]}
          rules={[{ required: true, message: requiredMessage }]}>
          <Select
            allowClear={true}
            showSearch={true}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            style={{ width: 200 }}
            placeholder={dictionary?.Class[language]}>
            {classes &&
              classes.map((el) => {
                return (
                  <Select.Option value={el.id} key={el.id}>
                    {el.year} {el.letter}
                  </Select.Option>
                );
              })}
          </Select>
        </Form.Item> */}
        <Form.Item
          name="langId"
          label={dictionary?.Lang[language]}
          rules={[{ required: true, message: requiredMessage }]}>
          <Select
            allowClear={true}
            showSearch={true}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            disabled={true}
            style={{ width: 200 }}
            placeholder={dictionary?.Lang[language]}>
            {languagesType &&
              languagesType.map((el) => {
                return (
                  <Select.Option value={el.id} key={el.id}>
                    {el.name}
                  </Select.Option>
                );
              })}
          </Select>
        </Form.Item>
        <Form.Item
          name="groupId"
          label={dictionary?.Group[language]}
          rules={[{ required: true, message: requiredMessage }]}>
          <Select
            allowClear={true}
            showSearch={true}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            style={{ width: 200 }}
            placeholder={dictionary?.Group[language]}
            onChange={(e, data) => onChangeGroup(data?.value)}>
            {studentGroups &&
              studentGroups.map((el) => {
                return (
                  <Select.Option value={el.id} key={el.id}>
                    {el.name}
                  </Select.Option>
                );
              })}
          </Select>
        </Form.Item>
        <Form.Item
          name="topicsId"
          label={dictionary?.TopicName[language]}
          rules={[{ required: true, message: requiredMessage }]}
          shouldUpdate={() => true}>
          <Select
            allowClear={true}
            showSearch={true}
            mode="multiple"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            style={{ width: 200 }}
            placeholder={dictionary?.TopicName[language]}>
            {topics &&
              topics
                .filter((topic) => topic.subjectId === currentFilter?.subjectId)
                .map((el) => {
                  return (
                    <Select.Option value={el.id} key={el.id}>
                      {el.name}
                    </Select.Option>
                  );
                })}
          </Select>
        </Form.Item>
        <Form.Item
          label={dictionary?.NumberOfVariants[language]}
          name="numberOfVariants"
          rules={[
            { required: true, message: requiredMessage },
            {
              pattern: integerRegex,
              message: dictionary?.OnlyNumber[language],
            },
            {
              pattern: maxVariantRegex,
              message: dictionary?.InvalidStudyYear[language].replace(
                'diapasone',
                `0-${groupStudentsCount}`,
              ),
            },
          ]}>
          <Input placeholder={dictionary?.NumberOfVariants[language]} />
        </Form.Item>
        <Form.Item
          name="examDate"
          label={dictionary?.ExamStartDate[language]}
          {...rulesForDates('examDate', date)}
          rules={[{ required: true, message: requiredMessage }]}>
          <DatePicker
            placeholder={dictionary?.ExamStartDate[language]}
            style={{ width: 250 }}
            format={dateFormat}
            onChange={setDate}
          />
        </Form.Item>
        <Form.Item
          name="startTime"
          label={dictionary?.ExamStartTime[language]}
          {...rulesForDates('startTime', date)}
          rules={[{ required: true, message: requiredMessage }]}>
          <TimePicker
            format={timeFormat}
            placeholder={dictionary?.ExamStartTime[language]}
            style={{ width: 250 }}
            onChange={setDate}
          />
        </Form.Item>
        <Form.Item
          name="endDate"
          label={dictionary?.ExamEndDate[language]}
          {...rulesForDates('endDate', date)}
          rules={[{ required: true, message: requiredMessage }]}>
          <DatePicker
            placeholder={dictionary?.ExamEndDate[language]}
            style={{ width: 250 }}
            format={dateFormat}
            onChange={setDate}
          />
        </Form.Item>
        <Form.Item
          name="endTime"
          label={dictionary?.ExamEndTime[language]}
          {...rulesForDates('endTime', date)}
          rules={[{ required: true, message: requiredMessage }]}>
          <TimePicker
            locale={ruRU}
            format={timeFormat}
            placeholder={dictionary?.ExamEndTime[language]}
            style={{ width: 250 }}
            onChange={setDate}
          />
        </Form.Item>
        <Form.Item
          name="examDuration"
          label={dictionary?.ExamDuration[language]}
          rules={[
            { required: true, message: requiredMessage },
            {
              pattern: integerRegex,
              message: dictionary?.OnlyNumber[language],
            },
          ]}>
          <Input placeholder={dictionary?.ExamDuration[language]} />
        </Form.Item>
        <Form.Item
          label={dictionary?.TotalNumberOfQuestions[language]}
          name="numberOfQuestions"
          rules={[
            { required: true, message: requiredMessage },
            {
              pattern: integerRegex,
              message: dictionary?.OnlyNumber[language],
            },
            {
              pattern: new RegExp(`^${numberOfQuestionsRegex}$`),
              message: dictionary?.TotalNumberOfQuestionsRegex[language],
            },
          ]}>
          <Input placeholder={dictionary?.TotalNumberOfQuestions[language]} />
        </Form.Item>

        <Form.List name="options">
          {(fields, { add, remove }) => {
            return (
              <div>
                {fields.map((field) => {
                  return (
                    <div className="box-exam" key={field.key}>
                      <Form.Item
                        label={dictionary?.QuestionType[language]}
                        name={[field.name, 'questionTypeId']}
                        fieldKey={[field.fieldKey, 'questionTypeId']}
                        {...rulesForQuestionTypeId(field.name)}>
                        <Select
                          allowClear={true}
                          showSearch={true}
                          filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          }
                          style={{ width: 200 }}
                          placeholder={dictionary?.QuestionType[language]}
                          onChange={getQuestionsCount}>
                          {questionTypes &&
                            questionTypes.map((el) => {
                              return (
                                <Select.Option value={el.id} key={el.id}>
                                  {el.name}
                                </Select.Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                      <Form.Item shouldUpdate noStyle>
                        {() => {
                          return (
                            <Form.Item
                              shouldUpdate
                              label={dictionary?.NumberOfQuestions[language]}
                              name={[field.name, 'amount']}
                              fieldKey={[field.fieldKey, 'amount']}
                              rules={[
                                { required: true, message: requiredMessage },
                                {
                                  pattern: integerRegex,
                                  message: dictionary?.OnlyNumber[language],
                                },
                                {
                                  pattern: new RegExp(`^${maxLevelsSizeRegex(field.name)}$`),
                                  message:
                                    maxLevelRegex(field.name, 'A') === '0' &&
                                    maxLevelRegex(field.name, 'B') === '0' &&
                                    maxLevelRegex(field.name, 'C') === '0'
                                      ? dictionary?.QuestionsAreNotEnough[language]
                                      : dictionary?.TotalNumberOfLevelQuestions[language],
                                },
                              ]}>
                              <Input
                                placeholder={dictionary?.NumberOfQuestions[language]}
                                onChange={() => {
                                  var amount = 0;
                                  form
                                    .getFieldValue('options')
                                    .map((el) => (amount += parseInt(el?.amount)));
                                  setNumberOfQuestionsRegex(amount);
                                  form.validateFields([
                                    'numberOfQuestions',
                                    ['options', field.name, 'questionTypeId'],
                                    ['options', field.name, 'LevelA'],
                                    ['options', field.name, 'LevelB'],
                                    ['options', field.name, 'LevelC'],
                                  ]);
                                }}
                              />
                            </Form.Item>
                          );
                        }}
                      </Form.Item>
                      <Form.Item
                        label={dictionary?.LevelA[language]}
                        name={[field.name, 'LevelA']}
                        fieldKey={[field.fieldKey, 'LevelA']}
                        rules={[
                          { required: true, message: requiredMessage },
                          {
                            pattern: integerRegex,
                            message: dictionary?.OnlyNumber[language],
                          },
                          {
                            pattern: maxIntegerLengthRegex(maxLevelRegex(field.name, 'A')),
                            message: dictionary?.TotalNumberOfLevels[language].replace(
                              'repText',
                              `${maxLevelRegex(field.name, 'A')}`,
                            ),
                          },
                        ]}>
                        <Input
                          placeholder={dictionary?.LevelA[language]}
                          onChange={() => {
                            form.validateFields([
                              ['options', field.name, 'amount'],
                              ['options', field.name, 'questionTypeId'],
                            ]);
                          }}
                        />
                      </Form.Item>
                      <Form.Item
                        label={dictionary?.LevelB[language]}
                        name={[field.name, 'LevelB']}
                        fieldKey={[field.fieldKey, 'LevelB']}
                        rules={[
                          { required: true, message: requiredMessage },
                          {
                            pattern: integerRegex,
                            message: dictionary?.OnlyNumber[language],
                          },
                          {
                            pattern: maxIntegerLengthRegex(maxLevelRegex(field.name, 'B')),
                            message: dictionary?.TotalNumberOfLevels[language].replace(
                              'repText',
                              `${maxLevelRegex(field.name, 'B')}`,
                            ),
                          },
                        ]}>
                        <Input
                          placeholder={dictionary?.LevelB[language]}
                          onChange={() => {
                            form.validateFields([
                              ['options', field.name, 'amount'],
                              ['options', field.name, 'questionTypeId'],
                            ]);
                          }}
                        />
                      </Form.Item>
                      <Form.Item
                        label={dictionary?.LevelC[language]}
                        name={[field.name, 'LevelC']}
                        fieldKey={[field.fieldKey, 'LevelC']}
                        rules={[
                          { required: true, message: requiredMessage },
                          {
                            pattern: integerRegex,
                            message: dictionary?.OnlyNumber[language],
                          },
                          {
                            pattern: maxIntegerLengthRegex(maxLevelRegex(field.name, 'C')),
                            message: dictionary?.TotalNumberOfLevels[language].replace(
                              'repText',
                              `${maxLevelRegex(field.name, 'C')}`,
                            ),
                          },
                        ]}>
                        <Input
                          placeholder={dictionary?.LevelC[language]}
                          onChange={() => {
                            form.validateFields([
                              ['options', field.name, 'amount'],
                              ['options', field.name, 'questionTypeId'],
                            ]);
                          }}
                        />
                      </Form.Item>
                      <Button
                        type="primary"
                        shape="round"
                        danger={true}
                        style={{ marginLeft: 80, marginBottom: 25 }}
                        icon={<MinusCircleOutlined />}
                        onClick={() => remove(field.name)}>
                        {dictionary?.Delete[language]}
                      </Button>
                    </div>
                  );
                })}
                <Form.Item labelAlign="right">
                  <Button
                    type="primary"
                    shape="round"
                    style={{ marginTop: 20, marginLeft: 80 }}
                    icon={<PlusOutlined />}
                    onClick={() => add()}>
                    {dictionary?.AddMore[language]}
                  </Button>
                </Form.Item>
              </div>
            );
          }}
        </Form.List>
        <Form.Item wrapperCol={{ offset: 8 }}>
          <Button type="primary" htmlType="submit" onClick={() => onSaveExams()}>
            {dictionary?.Save[language]}
          </Button>
        </Form.Item>
      </Form>
    </React.Fragment>
  );
}

export default CreateExam;
